import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EditSponsor from './EditSponsor'

class ParselEditSponsor extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EditSponsor} {...props}/>
   )
 }
}



export default ParselEditSponsor;
